export default __webpack_public_path__ + "static/media/upload-book-white.faba6222.svg";